import React from 'react';

function Support() {
  return (
    <div className="support-container">
      <div className="auth-logo" style={{ textAlign: 'center', marginTop: '20px' }}>
        <a href="/">
          <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" />
        </a>
      </div>
      <h1 style={{ textAlign: 'center', margin: '20px 0' }}>Suport</h1>

      <p>
        Aceasta este pagina de asistență pentru aplicație și subscripții. Dacă ai întrebări
        legate de activarea abonamentului (Apple/PayPal), facturare, resetare parolă sau accesul în aplicație,
        ne poți contacta folosind detaliile de mai jos.
      </p>

      <h2>Contact</h2>
      <ul>
        <li>Email: <a href="mailto:developer@m.ro">developer@m.ro</a></li>
        <li>Telefon: <a href="tel:+40756141219">+40 756 141 219</a></li>
      </ul>

      <h2>Subiecte frecvente</h2>
      <ul>
        <li>
          <strong>Abonamente Apple</strong>: dacă ai cumpărat pe iOS și nu vezi conținutul premium,
          deschide aplicația și folosește opțiunea de „restore” (restaurare abonament) din secțiunea cont.
        </li>
        <li>
          <strong>Abonamente PayPal</strong>: după aprobare, autentifică-te în aplicație cu adresa de email folosită
          la plată. Dacă nu apare ca activ, așteaptă câteva minute și reîncarcă pagina contului.
        </li>
        <li>
          <strong>Recuperare cont / resetare parolă</strong>: folosește fluxul de „Resetare parolă” din ecranul de Login.
        </li>
        <li>
          <strong>Disputarea tranzacțiilor</strong>: consultă pagina „Disputarea tranzacțiilor” și contactează-ne înainte
          de a iniția o dispută la procesator.
        </li>
      </ul>

      <h2>Resurse utile</h2>
      <ul>
        <li><a href="/about">Despre noi</a></li>
        <li><a href="/terms">Termeni și condiții</a></li>
        <li><a href="/privacy">Politica de confidențialitate</a></li>
        <li><a href="/dispute">Disputarea tranzacțiilor</a></li>
      </ul>
    </div>
  );
}

export default Support;


